import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { EditType } from './EditType';
import { P2GLink, P2GText } from '@parcel2go/core-ui';
import ItemProtectionSummaryDrop from './ItemProtectionSummaryDrop';
import P2GContentDropDown from '../../P2GContentDropDown';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  item: SmartSendItemApiModel;
  edit?: (type: EditType) => void;
  section: string;
  wrapper: (content: React.ReactNode) => React.ReactNode;
  isMobile: boolean;
}

export default function ItemProtectionSummary(props: props) {
  const coverPercentage = props.item.State.validation.QuoteState.Quote.Options[0].CoverPercentage || 0;
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  // const costToIncreaseCover = useMemo(() => {
  //   if (props.item.State.validation.QuoteState.Quote.Options[0]) {
  //     let ae = props.item.State.validation.QuoteState.Quote.Options[0].AvailableExtras;
  //     if (ae.find((x) => x.Id == ExtendedBaseCoverExtra)) {
  //       return ae.find((x) => x.Id == ExtendedBaseCoverExtra).Price;
  //     }
  //     if (ae.find((x) => x.Id == CoverExtra)) {
  //       return ae.find((x) => x.Id == CoverExtra).Price;
  //     }
  //   }
  //   return 0;
  // }, []);

  if (coverPercentage === 100) {
    return props.wrapper(
      props.isMobile ? (
        <P2GLink onClick={() => props.edit?.('PROTECTION')}>
          <P2GText variant="body2" colour="primary">
            <strong style={{ color: '#629833' }}>{t('FULL_PROTECTION', { defaultValue: 'Full Protection' })}</strong>
          </P2GText>
        </P2GLink>
      ) : (
        <P2GText variant="body2" colour="primary">
          <strong style={{ color: '#629833' }}>{t('FULL_PROTECTION', { defaultValue: 'Full Protection' })}</strong>
        </P2GText>
      )
    );
  }

  if (coverPercentage === 0) {
    return props.wrapper(
      props.isMobile ? (
        <P2GLink onClick={() => props.edit?.('PROTECTION')}>
          <P2GText variant="body2" colour="error">
            <strong>{t('NO_PROTECTION', { defaultValue: 'No Protection' })}</strong>
          </P2GText>
        </P2GLink>
      ) : (
        <P2GContentDropDown
          placement="bottom-end"
          control={
            <P2GLink>
              <P2GText variant="body2" colour="error">
                <strong>{t('NO_PROTECTION', { defaultValue: 'No Protection' })}</strong>
              </P2GText>
            </P2GLink>
          }
        >
          <ItemProtectionSummaryDrop item={props.item} />
        </P2GContentDropDown>
      )
    );
  }

  return props.wrapper(
    props.isMobile ? (
      <P2GLink onClick={() => props.edit?.('PROTECTION')}>
        <P2GText variant="body2" colour="error">
          <strong style={{ color: 'rgb(233 148 43)' }}>
            {t('NOT_FULLY_PROTECTED', { defaultValue: 'Not Fully Protected' })}
          </strong>
        </P2GText>
      </P2GLink>
    ) : (
      <P2GContentDropDown
        placement="bottom-end"
        control={
          <P2GLink>
            <P2GText variant="body2" colour="error">
              <strong style={{ color: 'rgb(233 148 43)' }}>
                {t('NOT_FULLY_PROTECTED', { defaultValue: 'Not Fully Protected' })}
              </strong>
            </P2GText>
          </P2GLink>
        }
      >
        <ItemProtectionSummaryDrop item={props.item} />
      </P2GContentDropDown>
    )
  );
}
